import { SectionProductTabsSeoKeywords } from "./SectionProductTabsSeoKeywords";
import { SectionProductTabsLandscapesAb } from "./SectionProductTabsLandscapesAb";

export const SectionProductTabs = () => (
  <div className="pl-4 border-l-2 border-primary/20 space-y-2">
    <SectionProductTabsSeoKeywords />
    <SectionProductTabsLandscapesAb />
  </div>
);
